import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { AuthService } from '../../auth/auth.service';
import { routes } from '../../routes/routes';

@Component({
  selector: 'app-email-verification-result-page',
  templateUrl: './email-verification-result-page.component.html',
  styleUrls: ['./email-verification-result-page.component.scss'],
})
export class EmailVerificationResultPageComponent implements OnInit {
  success = false;
  error: string | null = null;

  protected readonly routes = routes;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
  ) {}

  ngOnInit() {
    // Read URL parameters
    const params = this.activatedRoute.snapshot.queryParams;
    this.success = params['success'] === 'true';
    this.error = params['error'] || null;
  }

  async navigateToLogin() {
    await this.authService.logout();
    await this.router.navigateByUrl(routes.login.url());
  }
}
